import React from "react";
import Splash from "../../components/splash/Splash";
import Customers from "../../components/customers/Customers";
import Services from "../../components/services/Services";
import News from "../../components/news/News";
import CtaBand from "../../components/ctaband/CtaBand";
import ScrollReveal from "../../components/scroll/ScrollReveal";
import "./Home.css";

const stats = [
  { value: "50+", label: "successful projects" },
  { value: "$2M+", label: "client savings" },
  { value: "40–60%", label: "typical AWS bill reduction" },
  { value: "24/7", label: "support coverage" },
];

const Home = () => {
  return (
    <React.Fragment>
      <Splash />
      <Customers />
      <ScrollReveal>
        <Services />
      </ScrollReveal>
      <section className="stats-band blueprint">
        <div className="container stats-grid">
          {stats.map((stat) => (
            <div className="stat" key={stat.label}>
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>
      <ScrollReveal>
        <News />
      </ScrollReveal>
      <ScrollReveal>
        <CtaBand />
      </ScrollReveal>
    </React.Fragment>
  );
};

export default Home;
